import { AxiosResponse } from "axios";
import * as API from "middleware/api";
import { PolygonGeneralForm } from "pages/polygons/general/types";
import { RainsRequestParamsType } from "reducers/types/rainModal";
import { PricingMiddlewareType } from "reducers/types/regions";
import {
  RainCreationRequestType,
  RainCreationResponseType,
  RainUpdateRequestType,
  RainsResponseType,
  RainValidationResponseType,
  RainValidationRequestType,
} from "sagas/types/rainModal";
import {
  OriginsResponseType,
  RegionDetailResponseType,
  RegionsResponseType,
  UpdatePricingResponseType,
  UpdateRegionDetailResponseType,
  UpdateWorkzoneCapacityPayloadType,
  WorkzonesResponseType,
} from "sagas/types/regions";
import { FilterTransactionsType } from "sagas/types/transactions";

export const getRegions = (): Promise<
  AxiosResponse<API.ApiResponse<RegionsResponseType>>
> => API.get(`/ms-admin-rest/api/v1.0/regions`);

export const getOrigins = (params: FilterTransactionsType): Promise<
  AxiosResponse<API.ApiResponse<OriginsResponseType>>
> => API.get(`/ms-admin-rest/api/v1.0/transactions/origins`, params);

export const getWorkzonesByRegion = (
  regionId: string
): Promise<AxiosResponse<API.ApiResponse<WorkzonesResponseType>>> =>
  API.get(`/ms-admin-rest/api/v1.0/regions/${regionId}/work-zones`);

export const getPricingDetail = (
  regionId: string
): Promise<AxiosResponse<API.ApiResponse<RegionsResponseType>>> =>
  API.get(`/ms-admin-rest/api/v1.0/regions/${regionId}/pricing`);
export const updatePricingDetail = (
  params: PricingMiddlewareType
): Promise<AxiosResponse<API.ApiResponse<UpdatePricingResponseType>>> =>
  API.patch(
    `/ms-admin-rest/api/v1.0/regions/${params.id}/pricing`,
    params.body
  );

export const getRegionDetail = (
  regionId: string
): Promise<AxiosResponse<API.ApiResponse<RegionDetailResponseType>>> =>
  API.get(`/ms-admin-rest/api/v1.0/regions/${regionId}/details`);

export const updateRegionDetail = (
  params: PolygonGeneralForm
): Promise<AxiosResponse<API.ApiResponse<UpdateRegionDetailResponseType>>> => {
  const { id, ...body } = params;
  return API.put(`/ms-admin-rest/api/v1.0/regions/${id}/details`, body);
};

export const updateWorkzoneCapacity = (
  params: UpdateWorkzoneCapacityPayloadType
): Promise<AxiosResponse<API.ApiResponse<UpdateRegionDetailResponseType>>> => {
  return API.patch(`/ms-admin-rest/api/v1.0/regions/${params.id}/details`, {
    workZones: params.workzones,
  });
};

export const getRains = (
  params: RainsRequestParamsType,
  regionId: string
): Promise<AxiosResponse<RainsResponseType>> =>
  API.get(`/ms-admin-rest/api/v1.0/rains/${regionId}/details`, params);

export const addRain = (
  params: RainCreationRequestType
): Promise<AxiosResponse<RainCreationResponseType>> =>
  API.post(`/ms-admin-rest/api/v1.0/rains`, params);

export const deleteRain = (
  rainId: string
): Promise<AxiosResponse<RainCreationResponseType>> =>
  API.remove(`/ms-admin-rest/api/v1.0/rains/${rainId}`);

export const updateRain = (
  params: RainUpdateRequestType,
  rainId: string
): Promise<AxiosResponse<RainCreationResponseType>> =>
  API.patch(`/ms-admin-rest/api/v1.0/rains/${rainId}/details`, params);

export const validateRain = (
  params: RainValidationRequestType
): Promise<AxiosResponse<API.ApiResponse<RainValidationResponseType>>> =>
  API.post(`/ms-admin-rest/api/v1.0/rains/validate`, params);
